import { localize } from "@vee-validate/i18n";
import veeEn from "@vee-validate/i18n/dist/locale/en.json";
import { configure } from "vee-validate";
import { createI18n } from "vue-i18n";
import { z } from "zod";

import { makeZodI18nMap } from "@/lib/zod-vue-i18n";
import { loadLocaleMessages } from "@/locales/loadLocaleMessages";

const initialLocale = window.navigator.language.split("-")[0] ?? "fr";
const messages = loadLocaleMessages();

const i18n = createI18n({
  legacy: false,
  fallbackLocale: "fr",
  locale: initialLocale,
  messages: messages as never,
  datetimeFormats: {
    en: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      },
      table: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      },
      longDate: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      },
      time: {
        hour: "numeric",
        minute: "numeric",
      },
      month: {
        month: "long",
        year: "numeric",
      },
      fulldate: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      },
      shortDate: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      chart: {
        day: "numeric",
        month: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      },
    },
    fr: {
      short: {
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      longDate: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
      },
      month: {
        month: "long",
        year: "numeric",
      },
      table: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      },
      time: {
        hour: "numeric",
        minute: "numeric",
      },
      fulldate: {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      },
      shortDate: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      chart: {
        day: "numeric",
        month: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
    },
  },
});

configure({
  generateMessage: localize({
    en: veeEn,
    fr: (messages.fr as Record<string, never>).veeValidate,
  }),
});

z.setErrorMap(makeZodI18nMap(i18n));

export type I18n = typeof i18n;

export default i18n;
